import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/user.png'


const _hoisted_1 = { class: "top-bar" }
const _hoisted_2 = ["title"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "top-bar-user-td" }
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-regular fa-bell" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationsModal = _resolveComponent("NotificationsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        type: "button",
        class: "menu-button",
        title: _ctx.$t('Main menu'),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickMenu && _ctx.clickMenu(...args)))
      }, [
        _createElementVNode("i", {
          class: "fas fa-bars fa-2xl",
          style: _normalizeStyle({ color: _ctx.dark ? 'white' : 'black' })
        }, null, 4)
      ], 8, _hoisted_2)
    ]),
    _createElementVNode("div", {
      class: "top-bar-item-td cursor-pointer",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'home' })))
    }, [
      _createElementVNode("img", {
        class: "logo-button",
        src: _ctx.dark ? '/svg/icon_dark.svg' : '/svg/icon_light.svg',
        alt: "Logo Button"
      }, null, 8, _hoisted_3),
      _createElementVNode("img", {
        class: "logo-text",
        src: _ctx.dark ? '/svg/logo_dark.svg' : '/svg/logo_light.svg',
        alt: "Logo"
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (!_ctx.isLender && _ctx.walletVerified)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            id: "new-loan-top-bar-button",
            type: "button",
            class: "btn top-bar-btn-primary",
            title: _ctx.$t('New loan'),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleLoanButtonClick && _ctx.handleLoanButtonClick(...args)))
          }, _toDisplayString(_ctx.$t('New loan')), 9, _hoisted_6))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        id: "notifications-top-bar-button",
        type: "button",
        class: _normalizeClass(["top-bar-button", { 'has-notifications': _ctx.hasNotifications }]),
        title: _ctx.$t('Notifications'),
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openNotifications && _ctx.openNotifications(...args)))
      }, _hoisted_9, 10, _hoisted_7),
      _createElementVNode("button", {
        type: "button",
        class: "top-bar-button-img",
        title: _ctx.$t('User settings'),
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openUserSettings && _ctx.openUserSettings(...args)))
      }, [
        (_ctx.image)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "btn-image",
              src: _ctx.getAsset(_ctx.image),
              alt: "User"
            }, null, 8, _hoisted_11))
          : _createCommentVNode("", true),
        (!_ctx.image)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: _normalizeClass(["btn-image", { 'white-image': _ctx.theme === 'dark' }]),
              src: _imports_0,
              alt: "User"
            }, null, 2))
          : _createCommentVNode("", true)
      ], 8, _hoisted_10)
    ]),
    _createVNode(_component_NotificationsModal, {
      display: _ctx.displayNotifications,
      "onUpdate:display": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.displayNotifications) = $event))
    }, null, 8, ["display"])
  ]))
}